var page = {
	clickFlag 	: true,
	isFirst	 	: true,//アクセスが初回か
	category 	: "",
	filename 	: "",
	directoryNum: 0,
	directory 	: "",
	startOffset : 0,//クリック時点を覚える
	navnot: ".action a",
	pageTitle: "",
	init: function(){
		this.checkUrl();
		page.nav();
		window.addEventListener('popstate', function (e) {
			page.checkUrl();
		});
	},
	nav: function(){
		$(".list_items li a").not(page.navnot).off("click").on("click", function(e){
			e.preventDefault();
			let link = $(this).attr("href");
			page.push(link);
		});
	},
	push: function(link){
		window.history.pushState(null, null, link);
		if(page.clickFlag){
			page.clickFlag = false;
			page.checkUrl();
		}
	},
	changeContent: function(data){
		var defer = $.Deferred();
		var out_html 	= $(data),
			ttl 		= out_html.filter("title")[0].innerHTML,
			$content 	= $("#item_modal_content"),
			content 	= $("main#main_item_detail", out_html)[0],
			itemtitle 	= $("main#main_item_detail h3.ttl_item", out_html)[0],
			$selector 	= out_html.filter("[data-modal-size]")[0].innerHTML;
		console.log($selector)
		$("header h2").html($(itemtitle).text());
		$("[data-modal-size]").html($selector);
		$content.html(content);
		document.title = ttl;
		
		var imgArry = [];
		$("img", $content).each(function(){
			imgArry.push($(this).attr("src"));
		});
		//console.log(imgArry)
		if(imgArry > 0){
			preload.startLoad(imgArry.length,imgArry).done(function(){
				setTimeout(function(){
					defer.resolve();
				},50);
			});
		}else{
			setTimeout(function(){
				defer.resolve();
			},50);
		}
		return defer.promise();
	},
	changePage: function(){
		var $body = $("body");
		$.get(page.directory,{},function(data){
			//console.log(data)
			page.changeContent(data).done(function(){
				//console.log("content added");
				if(!$body.hasClass("modal_item")){
					$body.addClass("modal_item");
					setTimeout(function(){
						$body.addClass("modal_show_item");
						page.clickFlag = true;
						page.afterLoadPage();
					},50);
				}
			});
		});
	},
	closeModal: function(){
		var $body = $("body"),
			$modal = $("div[data-item-modal]");
		
		$body.removeClass("modal_show_item");
		$modal.off().on(transitionend, function(){
			$modal.off();
			$body.removeClass("modal_item");
			document.title = page.pageTitle;
			page.clickFlag = true;
		});
	},
	afterLoadPage: function(){
		detail.init();
		detailSlideshow.init();
		$("a.btn_close_modal").off().on("click", function(){
			var url 	= location.href;
			var prop 	= location.pathname;
			var propArry = prop.split("/");
			var url = "/" + propArry[propArry.length-2] + "/";
			page.push(url);
		});
		$(".select_size").off().on("click", function(){
			common.selectSize();
		});
	},
	checkUrl: function(){
		var url 	= location.href;
		var prop 	= location.pathname;
		var propArry = prop.split("/");
		var $body 	= $("body");
		page.directory = prop;
		page.category = propArry[1];
		page.filename = propArry[propArry.length-1];
		page.directoryNum = propArry.length;
		console.log(page.category, page.directory, page.directoryNum);
		//var isDetail = page.filename.indexOf(".html");
		var isDetail = (page.filename.indexOf("detail.html")>-1 || /\/items\/\d+/.test(location.pathname));
		console.log("isDetail:",isDetail);
		if(isDetail){
			//item一覧ページトップ
			if(page.isFirst){
				page.isFirst = false;
			}
			if(page.directory != "/item/"){
				page.changePage();
			}
		}else{
			if($body.hasClass("modal_show_item")){
				page.closeModal();
			}
		}
	}
}
document.addEventListener('DOMContentLoaded', function () {
	if(isPage === "itemdetail"){
		detail.init();
		detailSlideshow.init();
	}else{
		page.pageTitle = document.title;
		page.init();
	}
});